import { Dispatch } from 'redux';
import get from 'lodash/get';
import { getMenus, getUserInfo, getAccountBalance } from 'src/apis/auth';
import {
  SET_MENUS_AUTH,
  SET_MENUS_AUTH_SUCCESS,
  SET_AUTH_INFO,
  SET_ACCOUNT_BALANCE,
  SET_ACCOUNT_TYPE,
  SET_RECHARGE_VISIBLE,
} from '../type/bizGlobal.ts';

export default {
  GET_MENUS_AUTH() {
    return function (dispatch: Dispatch, getState: any) {
      return getMenus().then((resData: any = {}) => {
        const menus = resData.data || [];
        dispatch({ type: SET_MENUS_AUTH, payload: menus });
        dispatch({ type: SET_MENUS_AUTH_SUCCESS, payload: true });
        return menus;
      });
    };
  },
  GET_AUTH_INFO() {
    return function (dispatch: Dispatch, getState: any) {
      return getUserInfo().then((res) => {
        const authData = get(res, 'data');
        dispatch({ type: SET_AUTH_INFO, payload: authData });
        return authData;
      });
    };
  },
  GET_ACCOUNT_BALANCE() {
    return function (dispatch: Dispatch, getState: any) {
      return getAccountBalance().then((res) => {
        const data = get(res, 'data');
        dispatch({ type: SET_ACCOUNT_BALANCE, payload: data });
        return data;
      });
    };
  },
  GET_ACCOUNT_TYPE(type?: string) {
    return function (dispatch: Dispatch, getState: any) {
      const theType = type || localStorage.getItem('ACCOUNT_TYPE') || 'office';
      dispatch({ type: SET_ACCOUNT_TYPE, payload: theType });
    };
  },
  GET_RECHARGE_VISIBLE(visible: boolean) {
    return function (dispatch: Dispatch, getState: any) {
      dispatch({ type: SET_RECHARGE_VISIBLE, payload: visible });
    };
  },
};
